import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import FreeBooks from '@/components/screens/free-books/FreeBooks';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
// import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBookPage } from '@/interfaces/booksPage.interface';

interface IFreeBooksPageDynamic {
  books: IBookPage;
}

const FreeBooksPageDynamic: NextPage<IFreeBooksPageDynamic> = ({ books }) => {
  // useRedirectToFirstPage('/rating/books/');

  return <FreeBooks books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books?free_book=true&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default FreeBooksPageDynamic;
